import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'mage-react-router';
import { detectClient } from '@moka-fe/ats.utils';
import { cloneDeep } from 'lodash';

import mokaRequest from '@/tools/mokaRequest';

let codeStatus = {
  codeHasChanged: false,
  prevVersion: null,
  prevIsGrayReleased: false,
};

// 是否已经绑定过tab focus 事件监听
let hasBindVisibilitychange = false;

export function getCodeVersionStatus() {
  return cloneDeep(codeStatus);
}

function fetchCodeVersion(url, client, onVersionChange) {
  mokaRequest(url, {
    query: {
      client,
    },
  })
    .get()
    .then(({ version, isGrayReleased, forceRefresh }) => {
      const { prevIsGrayReleased, prevVersion } = codeStatus;
      // 如果没有previousVersion说明init方法没能成功获取版本, 那么接口返回的版本将成为初始化版本
      if (!prevVersion) {
        // 版本切换 清除 eng缓存
        window.sessionStorage.removeItem('_MOKA_ENV_');
        return (codeStatus = {
          prevVersion: version,
          prevIsGrayReleased: isGrayReleased,
          codeHasChanged: false,
        });
      }

      // 版本 或 灰度发生变化 才进入逻辑判断
      if (version !== prevVersion || isGrayReleased !== prevIsGrayReleased) {
        // 如果是强刷 不管是版本变化还是灰度变化
        if (forceRefresh) {
          // 则判断如果当前tab focus 则 直接弹不可关闭弹窗
          if (!document.hidden) {
            onVersionChange(forceRefresh); // true
          } else if (!hasBindVisibilitychange) {
            // 如果 blur状态 则 注册监听focus事件 focus 即 触发强刷
            // 用window.addEventListener('visibilitychange') 有兼容性问题故
            hasBindVisibilitychange = true;
            document.addEventListener('visibilitychange', () => {
              if (!document.hidden) {
                setTimeout(() => {
                  window.location.reload();
                });
              }
            });
          }
        } else if (isGrayReleased !== prevIsGrayReleased) {
          // 如果不需要强刷 且是灰度发生变化 则弹可关闭弹窗 可直接点刷新 也可关闭弹窗 标记状态 等待后续事件（menu按钮click）触发reload
          onVersionChange(forceRefresh); // false
        }
        // 如果是普通版本变化 则不弹窗 标记状态 等待后续事件（menu按钮click）触发reload

        // 版本变化和灰度变化 均更新状态
        // 等待后续事件（menu按钮点击 或 tab focus）触发 再reload
        codeStatus = {
          prevVersion: version,
          prevIsGrayReleased: isGrayReleased,
          codeHasChanged: true,
        };

        // 版本切换 清除 eng缓存
        window.sessionStorage.removeItem('_MOKA_ENV_');
      }
    });
}

function initCodeVersion({ version, isGrayReleased }) {
  codeStatus = { ...codeStatus, prevIsGrayReleased: isGrayReleased, prevVersion: version };
}

export default class AutoReload extends Component {
  static interval;

  static CLIENT_NAME = {
    MAIN: 'main',
    MOBILE: 'mobile',
    HR_MOBILE: 'hrMobile',
    HR_WEB: 'hrWeb',
    APPLY_MOBILE: 'applyMobile',
    APPLY_WEB: 'applyWeb',
    HEADHUNTER: 'headhunter',
  };

  fetchCodeVersion = () =>
    fetchCodeVersion(this.props.url, this.props.client, this.props.onVersionChange);

  getCodeVersionFromPage = () => {
    const { version, isGrayReleased } = detectClient();

    initCodeVersion({ version, isGrayReleased });
  };

  // 绑定定时器
  componentDidMount() {
    this.getCodeVersionFromPage();
    if (!AutoReload.interval) {
      AutoReload.interval = window.setInterval(this.fetchCodeVersion, this.props.tryDelay);
    }
  }

  // 清除定时器
  componentWillUnmount() {
    if (AutoReload.interval) {
      window.clearInterval(AutoReload.interval);
      delete AutoReload.interval;
    }
  }

  render() {
    // eslint-disable-next-line react/forbid-dom-props
    return <div style={{ display: 'none' }} />;
  }
}

// eslint-disable-next-line react/no-multi-comp
export class AutoReloadLink extends Component {
  onClickHandler = () => {
    if (this.props.onClick) {
      this.props.onClick();
    }
    if (codeStatus.codeHasChanged) {
      // 如果同步reload, 会导致刷新的页面是跳转之前的页面
      // 所以保证地址栏先被更新, 再刷新页面,这样可以保证页面的正常跳转
      setTimeout(() => {
        window.location.reload();
      });
    }
  };

  render() {
    const { to, children, className } = this.props;
    return (
      <Link to={to} onClick={this.onClickHandler} className={className}>
        {children}
      </Link>
    );
  }
}

AutoReload.propTypes = {
  url: PropTypes.string.isRequired,
  client: PropTypes.string.isRequired, // 可能得值: 'main' 'hrMobil' 'mobil' 'applyMobil'
  onVersionChange: PropTypes.func,
  tryDelay: PropTypes.number,
};

AutoReload.defaultProps = {
  className: '',
  url: '/',
  onVersionChange: () => {},
  tryDelay: 3 * 60 * 1000, // 3 min
};

AutoReloadLink.propTypes = {
  className: PropTypes.string,
  to: PropTypes.any.isRequired,
  onClick: PropTypes.func,
};
